module.exports = __webpack_public_path__ + "./assets/img/portfolio_5.dec3af47.jpg";